var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitBucketDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 0H60C26.8629 0 0 26.8629 0 60V196C0 229.137 26.8629 256 60 256H196C229.137 256 256 229.137 256 196V60C256 26.8629 229.137 0 196 0Z",
    fill: "#242938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2923 52.0292C45.4801 52.0189 44.6754 52.1832 43.9347 52.5107C43.1941 52.8382 42.5355 53.3208 42.0052 53.9247C41.4748 54.5286 41.0856 55.2392 40.8649 56.0065C40.6442 56.7738 40.5973 57.5792 40.7275 58.3662L64.3512 199.125C64.6454 200.848 65.5487 202.413 66.9023 203.547C68.2558 204.681 69.9732 205.31 71.7526 205.325H185.084C186.418 205.341 187.714 204.887 188.735 204.045C189.756 203.203 190.435 202.029 190.649 200.736L214.273 58.3935C214.403 57.6065 214.356 56.8012 214.135 56.034C213.914 55.2669 213.525 54.5565 212.994 53.9527C212.464 53.3489 211.805 52.8664 211.065 52.5391C210.324 52.2117 209.52 52.0475 208.707 52.0578L46.2923 52.0292ZM145.767 153.761H109.594L99.7999 103.537H154.532L145.767 153.761Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.616 103.467H154.431L145.673 153.651H109.529L66.852 203.371C68.2047 204.519 69.9292 205.157 71.7173 205.172H184.987C186.32 205.188 187.614 204.735 188.635 203.893C189.655 203.052 190.334 201.879 190.547 200.587L206.616 103.467Z",
    fill: "url(#paint0_linear_33_568)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_568",
    x1: 39228.9,
    y1: 3347.5,
    x2: 23538.7,
    y2: 23660.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitBucketDark);
export default __webpack_public_path__ + "static/media/BitBucket-Dark.bdd8ddc6e0169c1d6ddaedc9f2630b28.svg";
export { ForwardRef as ReactComponent };